import { AxiosError } from 'axios';
import { defaultCallApi, useApi } from '../..';
import { useLoader } from '../../../components/Loader';

const apiPath = `${process.env.REACT_APP_BROKER_MANAGEMENT_API_AUTH_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export function useAuthApi(
  errorHandler?: ((res: AxiosError<any, any>) => void) | null,
  callApi: (responseCall: any, apiCall: any) => Promise<any> = defaultCallApi,
) {
  const { addLoader, removeLoader } = useLoader();

  return useApi(
    apiUrl,
    errorHandler,
    async (responseCall, apiCall) => {
      addLoader();
      return callApi(responseCall, apiCall).finally(() => {
        removeLoader();
      });
    },
  );
}
